import { useLazyQuery } from "@apollo/client/react";
import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { GET_CONFORMIDADES } from "../../../data/graphQL/queries/Conformidades/getConformidades";
import moment from "moment";

export const useGetRows = (filters, setIsRefetchRequired) => {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [countByEtapa, setCountByEtapa] = useState({
    pendiente: 0,
    generado: 0,
    procesado: 0
  });

  const [getConformidades, { loading: loadingConformidades, data: dataConformidades }] = useLazyQuery(GET_CONFORMIDADES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (dataConformidades) {
      const conformidadesData = dataConformidades.conformidades?.valorEsperado || [];
      setRows(conformidadesData);

      const countByEtapaData = conformidadesData.reduce((acc, item) => {
        if (!!item?.fechaGestion && !item?.fechaProcesamiento) {
          acc.procesado += 1;
        } else if (!!item?.idConformidad && !item?.fechaGestion && !item?.fechaProcesamiento) {
          acc.generado += 1;
        } else if (!item?.idConformidad && !item?.fechaProcesamiento) {
          acc.pendiente += 1;
        }

        return acc;
      }, { pendiente: 0, generado: 0, procesado: 0 });

      setCountByEtapa(countByEtapaData);
      setIsRefetchRequired(false);
    }
  }, [dataConformidades]);

  useEffect(() => {
    if (!filters.txtFiltro || filters.txtFiltro.trim() === "") {
      setFilteredRows(rows);
      return;
    }

    const searchTerm = filters.txtFiltro.toLowerCase();
    const filtered = rows.filter((row) =>
      row.idEvaluacion?.toString().toLowerCase().includes(searchTerm) ||
      row.delegacion?.toString().toLowerCase().includes(searchTerm) ||
      row.paciente?.toString().toLowerCase().includes(searchTerm) ||
      row.cod_Cliente?.toString().toLowerCase().includes(searchTerm) ||
      row.cliente?.toString().toLowerCase().includes(searchTerm) ||
      moment(row.fDesde)?.format("DD/MM/YYYY")?.includes(searchTerm) ||
      moment(row.fHasta)?.format("DD/MM/YYYY")?.includes(searchTerm) ||
      moment(row.fechaGestion)?.format("DD/MM/YYYY")?.includes(searchTerm) ||
      moment(row.fechaProcesamiento)?.format("DD/MM/YYYY")?.includes(searchTerm) ||
      row.idConformidad?.toString().toLowerCase().includes(searchTerm)
    );
    setFilteredRows(filtered);
  }, [rows, filters.txtFiltro]);

  const handleSearch = useCallback(() => {
    if (!filters.mes || !filters.anio || [null, undefined].includes(filters.idMetodo) || [null, undefined].includes(filters.idDelegacion)) {
      toast.error("Todos los campos son obligatorios.");
      return;
    }

    const { txtFiltro, ...filter } = { ...filters };
    getConformidades({ variables: { filter } });
  }, [filters]);

  return {
    rows: filteredRows,
    setRows,
    loading: loadingConformidades,
    totalCount: rows?.length || 0,
    handleSearch,
    countByEtapa
  };
};